export default "__VITE_ASSET__BdeCU9zl__"